import { AUTH_TOKEN } from "./constants";
import { jwtDecode, JwtPayload } from "jwt-decode";

interface CustomJwtPayload extends JwtPayload {
  user: {
    mobileNumber: string;
  };
}

export function getLocalStorage(key: string) {
  try {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    console.error(
      `Error getting data from localStorage for key "${key}":`,
      error
    );
    return null;
  }
}

export function setLocalStorage(key: string, value: any) {
  try {
    const stringValue = JSON.stringify(value);
    localStorage.setItem(key, stringValue);
  } catch (error) {
    console.error(
      `Error setting data in localStorage for key "${key}":`,
      error
    );
  }
}

// The ZymedPedia backend tracks active sessions per device_type (+ b2c id) and caps
// them per account. device_type is minted once (UseDeviceInfo) and must survive a
// storage wipe: regenerating it makes the same device count as a new one, which
// fills the device limit and locks the user on /session-exceed.
const DEVICE_IDENTITY_KEYS = ["device_type", "device_info"];

export function clearLocalStorage() {
  const preserved = DEVICE_IDENTITY_KEYS.map((key) => [key, localStorage.getItem(key)] as const);
  localStorage.clear();
  preserved.forEach(([key, value]) => {
    if (value !== null) localStorage.setItem(key, value);
  });
}

export function getDecodedToken() {
  let token = localStorage.getItem(AUTH_TOKEN);
  token = token ? JSON.parse(token) : null;
  return token ? jwtDecode(token) : null;
}

export function deleteKeysFromLocalStorage(keys: string[]) {
  keys.forEach((key) => localStorage.removeItem(key));
}

export const getMobileNumber = () => {
  const token = getDecodedToken() as CustomJwtPayload;
  return token?.user?.mobileNumber;
};
